import React from 'react';
import { withStyles } from "@mui/styles";

const styles = {
  root: {
    fontWeight:200,
    fontSize:'0.85em'
  },
};

function InfoText({children, className='', classes, ...divProps}) {
  return <div className={`${classes.root} ${className}`} {...divProps}>{children}</div>;
};

export default withStyles(styles)(InfoText);
